import { ReactNode } from 'react'

import cn from '@/utilities/cn'

import './tooltip.scss'

type TooltipProps = {
  children: ReactNode
  oversized?: boolean
}

function Tooltip({ children, oversized }: TooltipProps) {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={cn('tooltip', { 'tooltip-tall': oversized })}
      onClick={event => {
        event.preventDefault()
        event.stopPropagation()
      }}
    >
      <div className="tooltip-arrow" />
      <div className={cn('tooltip-inner', { 'tooltip-inner-wide': oversized })}>{children}</div>
    </div>
  )
}

export default Tooltip
